// 📁 src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from "./api";
import socket from "./socket";

import LoginRegisterRole from "./components/LoginRegisterRole";
import GlobalHeader from "./components/GlobalHeader";
import AdminPanel from "./components/AdminPanel";
import GameLobby from "./components/GameLobby";
import LiveMap from "./LiveMap";

function AppWrapper() {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 Do NOT run session checks on /login
  const isLoginPage = location.pathname === "/login";

  // Handle game-ended globally
  useEffect(() => {
    socket.on("gameEnded", () => navigate("/lobby"));
    return () => socket.off("gameEnded");
  }, [navigate]);

  // SESSION CHECK — ONLY RUN WHEN NOT ON LOGIN PAGE
  useEffect(() => {
    if (isLoginPage) {
      setLoading(false);
      return; // 🚫 Prevent auth loop
    }

    const checkSession = async () => {
      try {
        const me = await axios.get("/api/me", { withCredentials: true });
        const status = await axios.get("/api/my-approval-status", { withCredentials: true });

        const user = me.data.user;
        setAuthenticated(true);

        // Admin always → admin panel
        if (user.role === "admin") {
          navigate("/admin");
          return;
        }

        // Dead players ALWAYS → lobby
        if (user.isAlive === false) {
          navigate("/lobby");
          return;
        }

        // Approved + game started → map
        if (status.data.approved && status.data.gameStarted) {
          navigate("/map");
          return;
        }

        // Everyone else → lobby
        navigate("/lobby");
      } catch (err) {
        setAuthenticated(false);
        navigate("/login"); // ⬅ Correct place for unauthenticated redirect
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [navigate, isLoginPage]);

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <GlobalHeader isAuthenticated={isAuthenticated} setAuthenticated={setAuthenticated} />

      <Routes>
        <Route path="/login" element={<LoginRegisterRole setAuthenticated={setAuthenticated} />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/map" element={<LiveMap />} />
        <Route path="/lobby" element={<GameLobby />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
